<efx-header>
  <!-- LOGO EQUIFAX -->
  <efx-header-logo [image]="'./assets/images/EFX_Logo.svg'" (click)="goToHome()">
  </efx-header-logo>


  @if (environmentText != 'prd') {
  <div style="padding: 10px; text-align: center;"><efx-badge type="warning" [showIcon]="false">Entorno de pruebas
      {{environmentText.toUpperCase()}}</efx-badge></div>
  }
  <!-- ITEMS MENU -->
  @if (regionSeleccionada) {
  <efx-header-section [hideInMobile]="false">
    @if (!isExternoRds) {
    <efx-header-dropdown-panel class="header-dropdown-disabled-icon" [labelTemplate]="funtionality" #Functionality>
      @for (itemMenu of menuItems; track itemMenu; let isLast = $last) {
      @if (visibleItem(itemMenu)) {
      <div class="d-flex align-items-center cursor-pointer p-2 item-menu"
        (click)="navIconMenu(itemMenu); Functionality.isOpen = false">
        <div class="me-2">
          <img alt="icon" [src]="itemMenu.icon" />
        </div>
        <div class="fs-12px">
          {{itemMenu.title}}
        </div>
      </div>
      }
      }
    </efx-header-dropdown-panel>
    }
    <!-- <ng-container *ngFor="let itemMenu of menuItems">
      <img *ngIf="visibleItem(itemMenu)" alt="icon" class="pill-image" [src]="itemMenu.icon" efxTooltip
        efxTooltipMode="dark" efxTooltipPlacement="bottom" [efxTooltipTitle]="itemMenu.title"
        (click)="navIconMenu(itemMenu)" />
      </ng-container> -->
  </efx-header-section>
  }


  <!-- Notification Init -->
  <!-- <efx-header-section [hideInMobile]="false">

  <efx-header-dropdown-panel class="header-dropdown-disabled-icon" [labelTemplate]="notification" #Notification>

    <div class="cursor-pointer p-1" *ngFor="let notification of notifications;let isLast = last">

      <div class="container-notification d-block "
        [ngClass]="{'border-bottom-1': !isLast}" >
        <div class="title">
          {{notification.title}}
        </div>
        <div class="description">{{notification.description}}</div>
        <div class="date">{{notification.date}}</div>
      </div>

    </div>
  </efx-header-dropdown-panel>
</efx-header-section> -->


  <ng-template #funtionality>
    <div>
      <img class="pill-image" src="assets/images/app_menu.svg" alt="Funcionalidades" />
    </div>
    <!-- <efx-header-icon-button icon="apps" label="Funcionalidades" [isActive]="true" titleText="Funcionalidades"
    [hideInMobile]="true">
  </efx-header-icon-button> -->
  </ng-template>


  <ng-template #notification>
    <efx-notification-badge type="info" [hideInMobile]="true" tooltipText="Notificaciones"
      [notificationCount]="notifications.length" ariaLabel="badge.notification.ariaLabel"></efx-notification-badge>
  </ng-template>
  <!-- Notification end -->
  <!-- COUNTRY LIST -->
  @if (regionSeleccionada) {
  <efx-header-section [hideInMobile]="false">
    <!-- INTERNAL LIST COUNTRY -->
    @if (!publicDM;) {
    <efx-header-dropdown-panel [labelTemplate]="countryList" id="country-list" #Section>
      @for (country of listCountry; track country) {
      <div class="cursor-pointer p-1" (click)="switchCountry(country); Section.isOpen = false">
        <img [src]="'./assets/icons/' + country.getCode() + '.png'" class="efx-img-flag me-2" alt="" />
        {{ country.getName() }}
      </div>
      }
    </efx-header-dropdown-panel>
    }
    <!-- VIP PAIS -->
    @if (publicDM) {
    <section [ngTemplateOutlet]="countryList"></section>
    }
  </efx-header-section>
  }

  <!-- USER SECTION -->
  <efx-header-section [hideInMobile]="true">
    <efx-header-dropdown-panel [labelTemplate]="userName">
      <span class="ms-2 text-user cursor-pointer" (click)="logoutSessionGoToHome()">Salir</span>
    </efx-header-dropdown-panel>
  </efx-header-section>
</efx-header>

<!-- TEMPLATE PARA IMG BANDERA -->
<ng-template #countryList>
  <img [src]="'./assets/icons/' + regionSeleccionada.getCode() + '.png'" class="efx-img-flag" alt="" />
</ng-template>

<!-- TEMPLATE PARA USER -->
<ng-template #userName>
  <span class="pill">
    {{ user.getName() | firstCharacter }}
  </span>
  <span class="text-user">&nbsp;{{user.getName()}}</span>
</ng-template>
